import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";
import type { RenderCboxFn } from "~/features/orders/common/components/v2/QuoteTable/types";
import QuoteLineHeaderSection from "./QuoteLineHeaderSection";
import { QuotePartsList } from "./QuotePartsList";
import { ProductHeader } from "./ProductHeader";
import {
  BorderLeftWrapper,
  ContainerStack,
  QuoteHeaderSummaryContainer,
} from "../common/components/v2/OrderAndQuoteSharedStyles";

interface SimpleQuoteRowProps {
  quoteLine: QuoteLineMO;
  renderCheckbox: RenderCboxFn;
}

export const SimpleQuoteRow = ({ quoteLine, renderCheckbox }: SimpleQuoteRowProps) => {
  const content = (
    <>
      <ProductHeader quoteLine={quoteLine} />
      <QuotePartsList quoteLine={quoteLine} renderCheckbox={renderCheckbox} />
    </>
  );
  return (
    <ContainerStack>
      <QuoteLineHeaderSection
        quoteLine={quoteLine}
        includeQuoteLine={quoteLine.parts.length < 2}
        renderCheckbox={renderCheckbox}
      />
      <QuoteHeaderSummaryContainer>
        {quoteLine.parts.length > 1 ? <BorderLeftWrapper>{content}</BorderLeftWrapper> : content}
      </QuoteHeaderSummaryContainer>
    </ContainerStack>
  );
};
